export const HYDRATION_QUERY_KEYS = {
  latestSessionEvents: ['hydration', 'latestSessionEvents'] as const,
  sessionStatuses: ['hydration', 'sessionStatuses'] as const,
  hostStatuses: ['hydration', 'hostStatuses'] as const,
} as const
